import React, { FC, useEffect, useRef, useState } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";

declare global {
    interface Window {
        usabilla?: any;
    }
}


const enum fields {
    id = "id",
    
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.id]: string;
    }
}

export const ADIFeeedbackSurvey: FC<OwnProps> = ({fields}) => {
    useEffect(() => {
        window.usabilla ||
            (function () {
                const a: any = window;
                const d = a.document;
                const c: any = {};
                const f = d.createElement("div");
                let h = false;
                a.usabilla = function () {
                    (c.a = c.a || []).push(arguments);
                };
                a._ = c;
                c.ids = {};
                f.style.display = "none";

                (function () {
                    if (!d.body) return setTimeout(arguments.callee, 100);
                    d.body.insertBefore(f, d.body.firstChild).id = "usabilla";
                    h = true;
                })();

                a.usabilla.load = function (usabillaDomain: string, scriptId: string, config?: any) {
                    if (!c.ids[scriptId]) {
                        const e: any = (c.ids = {});
                        e.url = `//${usabillaDomain}/${scriptId}.js?s1`;
                        e.config = config;
                        setTimeout(() => {
                            if (!h) return setTimeout(arguments.callee, 100);
                            const b = d.createElement("iframe");
                            b.id = `usabilla-${scriptId}`;

                            /MSIE[ ]+6/.test(navigator.userAgent) && (b.src = "javascript:false");
                            f.appendChild(b);

                            try {
                                b.contentWindow.document.open();
                            } catch (err) {
                                (e.domain = d.domain),
                                    (b.src = `javascript:var d=document.open();d.domain='${e.domain}';`);
                            }

                            try {
                                const l = b.contentWindow.document;
                                l.write(
                                    [
                                        "<!DOCTYPE html><html><head></head><body onload=\"var d = document;d.getElementsByTagName('head')[0].appendChild(d.createElement('script')).src='",
                                        e.url,
                                        "'\"></body></html>",
                                    ].join(""),
                                );
                                l.close();
                            } catch (err) {
                                b.src = `javascript:var d=document;d.write("` + '");d.close();';
                            }

                            b.contentWindow.config = config;
                            b.contentWindow.SCRIPT_ID = scriptId;
                        }, 0);
                    }
                };
            })();
        if (window && window.usabilla) {
            window.usabilla.load("w.usabilla.com", "453f59fae942");
        }
    }, []);

    const containerStyle = {
        maxWidth: "400px",
        margin: "0 auto",
        padding: "30px 0px",
    };

   
    return (
        <>
            <div style={containerStyle}>
                <div ub-in-page={fields.id}></div>
            </div>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ADIFeeedbackSurvey,
    definition: {
        group: "Common",
        displayName: "ADI Feedback Surevey",
        fieldDefinitions: [
            {
                name: fields.id,
                displayName: "Usabilla Page Id",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
